var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"link non-text-transformation",attrs:{"data-cy":"dataCy","color":"primary","outlined":"","tile":""},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }